import { createAction, handleActions } from 'redux-actions';

const SET_FEED_STAR = 'feedBack/SET_FEED_STAR';

export const changeFeedStar = createAction(SET_FEED_STAR);

const initialState = {
  opinion:{
    star:5,
    starName:'매우만족'
  }
};

const feedBack = handleActions(
  {
    [SET_FEED_STAR]: (state, { payload: opinion }) => opinion,
  },
  initialState
);

export default feedBack;
